import * as types from "./types";
import {
    shareFileDownloadAxios,
} from "./services";

export async function fileSharingAction({ commit }, file) {
    commit(types.LOADING_DOCUMENT, true);
    try {
        const { data }= await shareFileDownloadAxios(file);
        commit(types.FILE_SHARING, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DOCUMENT, false);
    }

}